import { REQUEST } from '../../../utils/actionGenerator';
import { fork, take, all, call, put } from 'redux-saga/effects';
import { urls } from '../../../utils/urls';
import * as api from '../../../utils/api';
import { getCookie } from 'utils/cookies';
import { SET_LOADER } from '../../../components/App/store/actions';
import store from '../../../store/configureStore';
import { fetchEntity, fetchEntitySpawn } from '../../../store/saga';
import * as operationActions from './actions';
import { buildApiRequest } from 'utils/api';
import { delay } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { showToaster } from 'components/Toaster/action';

export function* watchGetEmailsListSagaOp() {
  while (true) {
    const { params } = yield take(operationActions.GET_EMAILS_LIST_OP[REQUEST]);
    yield fork(getEmailsList, params);
  }
}

export function* getEmailsList(params) {
  const request = api.getEmailsListRequestOperations.bind(null, params);
  yield fetchEntity(request, operationActions.getEmailsList, params);
}

export function* getConsignmentStates() {
  const request = api.consignmentStatesRequest.bind();
  yield fetchEntity(request, operationActions.getConsignmentStates, null);
}

export function* fetchTripCancellationReason() {
  const request = api.getCancelUncancelTripReasons.bind();
  yield fetchEntity(request, operationActions.getCancelUncancelTripReasons, null);
}
export function* postCancelTrip(params) {
  const request = api.postCancelTrip.bind(null, params);
  yield fetchEntity(request, operationActions.postCancelTrip, null);
}
export function* getDemandConfig() {
  const request = api.getFormConfigRequest.bind();
  yield fetchEntity(request, operationActions.getDemandConfig, null);
}

export function* getRcConfig() {
  const request = api.getRcConfigRequest.bind();
  yield fetchEntity(request, operationActions.getRcConfig, null);
}

export function* getExpenseTypes(params) {
  const request = api.expenseTypesRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getExpenseTypes, params);
}

export function* getExpenseTypesV3(params) {
  const request = api.expenseTypesV3Request.bind(null, params);
  yield fetchEntity(request, operationActions.getExpenseTypesV3, params);
}

export function* getRemarks(params) {
  const request = api.remarksRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getRemarks, params);
}

export function* getTdsInfo(params) {
  const request = api.TdsInfoRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getTdsInfo, params);
}

export function* getConsignments(params) {
  const request = api.getConsignmentsRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getConsignments, params);
}

export function* getOperationSearch(params) {
  const request = api.operationSearchRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getOperationSearch, params);
}

export function* getConsignerCodes(payload) {
  const request = api.getConsignerSuggestionsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.getConsignerCodes, payload);
}

export function* saveRcDetails(payload) {
  const request = api.getSaveRcDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.saveRcDetails, payload);
}

export function* submitInvoice(payload) {
  let request;
  if (payload?.method === 'PUT') {
    request = api.getUpdateInvoiceRequest.bind(null, payload);
  } else {
    request = api.getSaveInvoiceRequest.bind(null, payload);
  }
  yield fetchEntity(request, operationActions.submitInvoice, payload);
}

export function* submitPodStatus(payload) {
  let request = api.getPodStatusApiUrl.bind(null, payload);
  yield fetchEntity(request, operationActions.submitPodStatus, payload);
}

export function* submitInsurance(payload) {
  let request = api.getUpdateInsuranceRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.submitInsurance, payload);
}

export function* getBankDetails(params) {
  const request = api.getBankDetailsRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getBankDetails, params);
}

export function* getCurrentDocket(docketId) {
  const request = api.getCurrentDocketRequest.bind(null, docketId);
  yield fetchEntity(request, operationActions.getCurrentDocket, docketId);
}

export function* getDockets(params) {
  const request = api.getDocketsRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getDockets, params);
}

export function* getInvoices(params) {
  const request = api.getInvoicesRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getInvoices, params);
}

export function* getInsurance(params) {
  const request = api.getInsuranceRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getInsurance, params);
}

export function* viewFilesDocket(params) {
  const request = api.viewDocketFilesRequest.bind(null, params);
  yield fetchEntity(request, operationActions.viewFilesDocket, params);
}

export function* viewInvoiceDoc(params) {
  const request = api.viewInvoiceRequest.bind(null, params);
  yield fetchEntity(request, operationActions.viewInvoiceDoc, params);
}

export function* viewInsuranceDoc(params) {
  const request = api.viewInsuranceRequest.bind(null, params);
  yield fetchEntity(request, operationActions.viewInsuranceDoc, params);
}

export function* getAddressDetails(params) {
  const request = api.getAddressDetailsRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getAddressDetails, params);
}
export function* getAddressDetailsOperationV4(params) {
  const request = api.getAddressDetailsRequestOperationV4.bind(null, params);
  yield fetchEntity(request, operationActions.getAddressDetailsOperationV4, params);
}
export function* getViaPoints(params) {
  const request = api.getViaPointsRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getViaPoints, params);
}

export function* viewFreight(params) {
  const request = api.viewFreightRequest.bind(null, params);
  yield fetchEntity(request, operationActions.viewFreight, params);
}

export function* getTripDetails(params) {
  let requests = [api.tripDetailsRequest.bind(null, params), api.currentLocationRequest.bind(null, params)];

  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getTripDetails.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);
    // log error
  }
}

export function* updateReferenceId(params) {
  const request = api.updateReferenceIdRequest.bind(null, params);
  yield fetchEntity(request, operationActions.updateReferenceId, params);
}

export function* getBasicDetails(consignmentId) {
  const request = api.getBasicDetailsRequest.bind(null, consignmentId);
  yield fetchEntity(request, operationActions.getBasicDetails, consignmentId);
}

export function* getOperatorByPhone(phone) {
  const request = api.operatorByPhoneRequest.bind(null, phone);
  yield fetchEntity(request, operationActions.getOperatorByPhone, phone);
}

export function* getPaymentBillingData(params) {
  const request = api.getPaymentBillingDataRequest.bind(null, { params });
  yield fetchEntity(request, operationActions.getPaymentBillingData);
}

export function* submitBillingData(payload, id) {
  const request = api.submitPaymentBillingRequest.bind(null, payload, id);
  yield fetchEntity(request, operationActions.submitPaymentBilling);
}

export function* updateBasicDetail(payload) {
  const request = api.updateBasicDetailRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.updateBasicDetail, payload);
}

export function* deleteDocket(payload) {
  const request = api.deleteDocketRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.deleteDocket, payload);
}

export function* deleteInvoice(payload) {
  const request = api.deleteInvoiceRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.deleteInvoice, payload);
}

export function* updateLocation(payload) {
  const request = api.updateLocationRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.updateLocation, payload);
}

export function* updateStoppageReason(payload) {
  const request = api.updateStoppageReasonRequet.bind(null, payload);
  yield fetchEntity(request, operationActions.updateStoppageReason, payload);
}

export function* createViaPoint(payload) {
  const request = api.createViaPointRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.createViaPoint, payload);
}

export function* editViaPoint(payload) {
  const request = api.editViaPointRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editViaPoint, payload);
}

export function* settleOperator(payload) {
  const request = api.settleOperatorRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.settleOperator, payload);
}
export function* saveBasicDetails(payload) {
  const request = api.saveBasicDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.saveBasicDetails, payload);
}

export function* settleShipper(payload) {
  const request = api.settleShipperRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.settleShipper, payload);
}

export function* editVehicleDetails(payload) {
  const request = api.vehicleDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editVehicleDetails, payload);
}

export function* editDriverDetails(payload) {
  const request = api.driverDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editDriverDetails, payload);
}

export function* editInvoiceDetails(payload) {
  const request = api.editInvoiceDocRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editInvoiceDetails, payload);
}

export function* updateDemandDetails(payload) {
  const request = api.updateDemandDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.updateDemandDetails, payload);
}

export function* addExpense(payload) {
  const request = api.addExpenseRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.addExpense, payload);
}

export function* editExpense(payload) {
  const request = api.editExpenseRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editExpense, payload);
}

export function* updateFreightDetails(payload) {
  const request = api.updateFreightDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.updateFreightDetails, payload);
}

export function* updateOperatorFreightDetails(payload) {
  const request = api.updateOperatorFreightDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.updateOperatorFreightDetails, payload);
}

export function* createTransaction(payload) {
  const request = api.createTransactionRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.createTransaction, payload);
}

export function* editTransaction(payload) {
  const request = api.editTransactionRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editTransaction, payload);
}

export function* saveRcUrl(payload) {
  const request = api.saveRcUrlRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.saveRcUrl, payload);
}

export function* createDocket(payload) {
  const request = api.createDocketRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.createDocket, payload);
}

export function* sharePaymentLink(payload) {
  const request = api.sharePaymentLinkRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.sharePaymentLink, payload);
}

export function* triggerConsignerForBilti(payload) {
  const request = api.createTriggerConsignerRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.triggerConsignerForBilti, payload);
}
export function* updateVehicleState(payload) {
  const request = api.vehicleStateRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.updateVehicleState, payload);
  yield put(operationActions.getTripItinerary.request({ consignmentId: payload.consignmentId, itinerary: false }));
}

export function* updateTime(payload) {
  const request = api.updateTimeRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.updateTime, payload);
  yield put(operationActions.getTripItinerary.request({ consignmentId: payload.consignmentId, itinerary: false }));
}

export function* createInvoice(payload) {
  const request = api.createInvoiceRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.createInvoice, payload);
}

export function* editInvoice(payload) {
  const request = api.editInvoiceRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editInvoice, payload);
}

export function* editDocket(payload) {
  const request = api.editDocketRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editDocket, payload);
}

export function* editStartPoint(payload) {
  const request = api.editAddressPointRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editStartPoint, payload);
}

export function* editEndPoint(payload) {
  const request = api.editAddressPointRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.editEndPoint, payload);
}

export function* deleteExpense(payload) {
  const request = api.deleteExpenseRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.deleteExpense, payload);
}

export function* getRcUrl(payload) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(uploadRc, payload);
    if (response.res.ok) yield put(operationActions.getRcUrl.success(response.resp, payload));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* viewRcRelationDoc(params) {
  const request = api.viewValidationDocRequest.bind(null, params);
  yield fetchEntity(request, operationActions.viewRcRelationDoc, params);
}

export function* getRelationDocUrl(payload) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(uploadRelationDoc, payload);
    if (response.res.ok) yield put(operationActions.getRelationDocUrl.success(response.resp, payload));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* getInvoiceDocUrl(payload) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(uploadInvoiceDoc, payload);
    if (response.res.ok) yield put(operationActions.getInvoiceDocUrl.success(response.resp, payload));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* getInsuranceDocUrl(payload) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(uploadInsuranceDoc, payload);
    if (response.res.ok) yield put(operationActions.getInsuranceDocUrl.success(response.resp, payload));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* getDocketFileUpload(payload) {
  try {
    store.dispatch({ type: SET_LOADER });

    const response = yield call(uploadFilesDocket, payload);

    const type = payload.type;

    if (response.res.ok) yield put(operationActions.getDocketFileUpload.success(response.resp, type));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* uploadFreight(params) {
  try {
    store.dispatch({ type: SET_LOADER });
    const response = yield call(freightFile, params);
    if (response.res.ok) yield put(operationActions.uploadFreight.success(response.resp, params));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

function uploadRc(payload) {
  let requestPayload = { ...payload };
  return fetch(
    `${urls.rcUpload}?vehicle-number=${requestPayload.vehicleNumber}&file-name=${requestPayload.fileName}&doc-type=VEHICLE_RC`,
    {},
  )
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/octet-stream',
          },
          body: requestPayload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data, res: resp };
    });
}

function uploadRelationDoc(payload) {
  let requestPayload = { ...payload };
  return fetch(`${urls.getConsignments}/${requestPayload.consignmentId}/rc-relation-upload-url`, {
    headers: {
      'X-GOOGLE-TOKEN': getCookie('googleAuth'),
    },
  })
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'X-GOOGLE-TOKEN': getCookie('googleAuth'),
            'Content-Type': 'application/octet-stream',
          },
          body: requestPayload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data, res: resp };
    });
}

function uploadInvoiceDoc(payload) {
  let requestPayload = { ...payload };
  return fetch(`${urls.getConsignments}/upload-url?invoiceId=${requestPayload.invoiceId}`, {
    headers: {
      'X-GOOGLE-TOKEN': getCookie('googleAuth'),
    },
  })
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'X-GOOGLE-TOKEN': getCookie('googleAuth'),
            'Content-Type': 'application/octet-stream',
          },
          body: requestPayload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data, res: resp };
    });
}

function uploadInsuranceDoc(payload) {
  let requestPayload = { ...payload };
  return fetch(`${urls.getConsignments}/upload-url?invoiceId=${requestPayload.insuranceNumber}`, {
    headers: {
      'X-GOOGLE-TOKEN': getCookie('googleAuth'),
    },
  })
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'X-GOOGLE-TOKEN': getCookie('googleAuth'),
            'Content-Type': 'application/octet-stream',
          },
          body: requestPayload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data, res: resp };
    });
}

function uploadFilesDocket(payload) {
  let requestPayload = { ...payload };
  return fetch(`${urls.docketApi}/${requestPayload.docketId}/pod-upload-url?type=${requestPayload.type}`, {
    headers: {
      'X-GOOGLE-TOKEN': getCookie('googleAuth'),
    },
  })
    .then((response) => response.json())
    .then((response) => {
      return Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'X-GOOGLE-TOKEN': getCookie('googleAuth'),
            'Content-Type': 'application/octet-stream',
          },
          body: requestPayload.formData,
        }),
      ]);
    })
    .then(([response, resp]) => {
      return { resp: response.data.name, res: resp };
    });
}

function freightFile(params) {
  let payload = { ...params };
  return fetch(`${urls.getDemands}/${payload.demandId}/sfa-upload-url`, {})
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/octet-stream',
          },
          body: payload.formData,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data.name, res: resp };
    });
}

export function* getSupplyDetails(params) {
  let requests = [
    // api.getBasicDetailsRequest.bind(null, params),
    api.getSupplyDetailsRequest.bind(null, params),
    api.getTransactionsRequest.bind(null, params),
    api.getMgDetailsRequest.bind(null, params),
    api.getExpenseRequest.bind(null, params),
  ];

  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getSupplyDetails.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);

    // log error
  }
}

export function* getThirdPartyDetails(params) {
  let requests = [
    api.getThirdPartyTransactionsRequest.bind(null, params),
    api.getThirdPartyExpenseRequest.bind(null, params),
  ];

  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getThirdPartyDetails.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);

    // log error
  }
}

function* safeCall(apiCall, params, key) {
  try {
    return yield call(apiCall, params);
  } catch (error) {
    yield put(operationActions.getDemandDetails.failure({ key, error }));
    Sentry.captureException(error);
    return null;
  }
}

export function* getDemandDetails(params) {
  const responses = yield all({
    demandDetails: call(safeCall, api.getDemandDetailsRequest, params, 'demandDetails'),
    transactions: call(safeCall, api.getTransactionsRequest, params, 'transactions'),
    userDetails: call(safeCall, api.getUserDetailsRequest, params, 'userDetails'),
    expenses: call(safeCall, api.getExpenseRequest, params, 'expenses'),
    nbfcTransactions: call(safeCall, api.getTransactionsRequest, { ...params, type: 'NBFC' }, 'nbfcTransactions'),
  });

  yield put(operationActions.getDemandDetails.success(responses, params));
}

export function* viewUploadedDocument(params) {
  if (!!params) {
    let requests = [api.getUploadedDocumentUrlRequest2.bind(null, params)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      if (params.openType == 'window') {
        if (responses[0].data.message === 'Ok') {
          window.open(responses[0].data.data.url, '_blank');
        }
      } else {
        yield put(operationActions.getViewImageUrl.success(responses, params));
      }
    } catch (error) {
      //log(error)
    }
  }
}

export function* getActivityDetails(params) {
  let requests = [api.getCommentsRequest.bind(null, params), api.getAuditRequest.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getActivityDetails.success(responses, params));
  } catch (error) {
    // log error
    Sentry.captureException(error);
  }
}

export function* getCommentCategories(params) {
  let requests = [api.getCommentCategories.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getCommentCategories.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);

    // log error
  }
}

export function* getPodDetails(params) {
  let requests = [api.getPodDetails.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getPodDetails.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);

    // log error
  }
}

export function* getPodHistory(params) {
  let requests = [api.getPodHistory.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getPodHistory.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);

    // log error
  }
}

export function* viewPodDocument(params) {
  let requests = [api.viewPodDocument.bind(null, params)];
  try {
    const response = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.viewPodDocument.success(response, params));
  } catch (error) {
    Sentry.captureException(error);
    // log error
  }
}

// export function* uploadPodDocument(payload) {
//   const request = api.uploadPodDocumentRequest.bind(null, payload);
//   yield fetchEntity(request, operationActions.uploadPodDocument, payload);
// }

export function* uploadPodDocument(payload) {
  const formData = {
    fileName: payload.fileName.name,
    docType: payload.docType,
  };

  let requests = [api.uploadPodDocumentRequest.bind(null, formData)];

  try {
    store.dispatch({ type: SET_LOADER });
    const responses = yield all(requests.map((fn) => call(fn)));
    let imgResourceKey = responses[0].data.data.imgResourceKey;
    let resKey = {
      payload: imgResourceKey,
      // typeImg: action.typeImg,
    };

    const uploadUrl = responses[0].data.data.imgUrl;
    let requestURL2 = uploadUrl.toString();

    if (responses) {
      const response = yield buildApiRequest('PUT', requestURL2, payload.fileName);

      if (response.status === 200) {
        yield put(operationActions.uploadPodDocument.success(responses, payload));
      }
    }
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* postComment(payload) {
  const request = api.postCommentRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.postComment, payload);
}

export function* submitPodDetails(payload) {
  const request = api.postPodDetailsRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.submitPodDetails, payload);
}

export function* submitDelayReason(payload) {
  const request = api.saveDelayReasonRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.saveDelayReason, payload);
}

export function* submitCancelReason(payload) {
  const request = api.saveCancelReasonRequest.bind(null, payload);
  yield fetchEntity(request, operationActions.saveCancelReason, payload);
}

export function* getExtraExpensePolicyData(payload) {
  const request = api.getExtraExpenseRequest.bind(null, payload);
  try {
    const response = yield call(request);
    yield put(operationActions.getExtraExpensePolicy.success(response));
  } catch (error) {
    yield put(operationActions.getExtraExpensePolicy.failure());
    Sentry.captureException(error);
    // log error
  }
}

export function* getPodValidityRemark(params) {
  let requests = [api.getPodValidityRemarkRequest.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.podValidityRemark.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);

    // log error
  }
}

export function* getStatesDocket(params) {
  let requests = [api.getStatesDocketRequest.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getStatesForDocket.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);

    // log error
  }
}

export function* getTripMapDetails(params) {
  let requests = [api.getTripMapDetailsRequest.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getTripMapDetails.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);
  }
}

export function* getTripItinerary(params) {
  let requests = [api.getTripItineraryRequest.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getTripItinerary.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);
  }
}

export function* getDelayReasons(params) {
  let requests = [api.getDelayReasonsRequest.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getDelayReasons.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);
  }
}

export function* getCancelReasons(params) {
  let requests = [api.getCancelReasonsRequest.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.getCancelReasons.success(responses, params));
  } catch (error) {
    Sentry.captureException(error);
  }
}

export function* submitDelayReasonModal(params) {
  let requests = [api.submitDelayModal.bind(null, params)];
  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(operationActions.submitDelayModal.success(responses, params));
    console.log(params.payload.isGenerateEmail, 'params');

    params.payload.isGenerateEmail
      ? yield put(showToaster({ toasterMsg: 'Successfully Generated Email!', toasterType: 'success' }))
      : yield put(showToaster({ toasterMsg: 'Successfully Submitted!', toasterType: 'success' }));

    yield put(operationActions.resetDelayModal.reset());
    params.callbackFunc();
  } catch (error) {
    yield put(
      showToaster({ toasterMsg: error?.response?.data?.message ?? 'Something went wrong!', toasterType: 'error' }),
    );
    yield put(operationActions.submitDelayModal.failure(error));
    Sentry.captureException(error);
  }
}

export function* getImageProofDocketDetails(params) {
  const request = api.getImageProofDocketDetails.bind(null, params, null);
  try {
    const response = yield call(request);
    yield put(operationActions.getImageProofDocketDetails.success(response.data.data));
  } catch (error) {
    yield put(operationActions.getImageProofDocketDetails.failure());
    Sentry.captureException(error);
    // log error
  }
}

export function* getDelayModalData(params) {
  const request = api.getDelayModal.bind(null, params, null);
  try {
    let response = yield call(request);
    yield put(operationActions.getDelayModalData.success(response.data.data));
  } catch (error) {
    yield put(operationActions.getDelayModalData.failure());
    Sentry.captureException(error);
    // log error
  }
}

export function* submitDocketImages(params) {
  const request = api.submitDocketImage.bind(null, params);
  try {
    let response = yield call(request);
    yield put(operationActions.submitDocketImages.success(response.data.data));
    params.callbackFunc();
    yield put(showToaster({ toasterMsg: 'Successfully submitted!', toasterType: 'success' }));
  } catch (error) {
    yield put(operationActions.submitDocketImages.failure());
    yield put(
      showToaster({ toasterMsg: error?.response?.data?.message ?? 'Something went wrong!', toasterType: 'error' }),
    );
    Sentry.captureException(error);
    // log error
  }
}

export function* generateEwayBillNumber(params) {
  const request = api.generateEwayBillNumber.bind(null, params.ewayNumber, params.consignmentId);
  try {
    store.dispatch({ type: SET_LOADER });
    let response = yield call(request);
    if (response.status === 200) {
      yield put(operationActions.generateEwayBillNumber.success(response.data.data));

      yield delay(5000);

      const resp = yield call(api.checkBiltiStatus, {
        ewayNumber: params.ewayNumber,
        consignmentId: params.consignmentId,
      });

      if (resp.status === 200) {
        yield put(showToaster({ toasterMsg: 'Successfully generated!', toasterType: 'success' }));
      }
    }
  } catch (error) {
    yield put(operationActions.generateEwayBillNumber.failure());
    Sentry.captureException(error);
    yield put(
      showToaster({ toasterMsg: error?.response?.data?.message ?? 'Something went wrong!', toasterType: 'error' }),
    );
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* checkBiltiStatus(params) {
  const request = api.checkBiltiStatus.bind(null, params);
  try {
    let response = yield call(request);
    return response;
  } catch (error) {
    Sentry.captureException(error);
  }
}
// export function* submitPodFileDetails(payload) {
//   const request = api.postPodFileDetailsRequest.bind(null, payload);
//   yield fetchEntity(request, operationActions.submitPodFileDetails, payload);
// }

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetConsignmentStatesSaga() {
  while (true) {
    yield take(operationActions.GET_CONSIGNMENT_STATES[REQUEST]);
    yield fork(getConsignmentStates);
  }
}
export function* watchfetchTripCancellationReasonSaga() {
  while (true) {
    yield take(operationActions.FETCH_CANCEL_UNCANCEL_TRIP_REASONS[REQUEST]);
    yield fork(fetchTripCancellationReason);
  }
}
export function* watchCancelTripSaga() {
  while (true) {
    const { params } = yield take(operationActions.POST_CANCEL_TRIP[REQUEST]);
    yield fork(postCancelTrip, params);
  }
}

export function* watchGetExpenseTypesSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_EXPENSE_TYPES[REQUEST]);
    yield fork(getExpenseTypes, params);
  }
}

export function* watchGetExpenseTypesV3Saga() {
  while (true) {
    const { params } = yield take(operationActions.GET_EXPENSE_TYPES_V3[REQUEST]);
    yield fork(getExpenseTypesV3, params);
  }
}

export function* watchGetRemarksSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_REMARKS[REQUEST]);
    yield fork(getRemarks, params);
  }
}

export function* watchGetTdsInfoSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_TDS_INFO[REQUEST]);
    yield fork(getTdsInfo, params);
  }
}

export function* watchViewFreightSaga() {
  while (true) {
    const { params } = yield take(operationActions.VIEW_FREIGHT[REQUEST]);
    yield fork(viewFreight, params);
  }
}

export function* watchGetDemandConfigSaga() {
  while (true) {
    yield take(operationActions.GET_DEMAND_CONFIG[REQUEST]);
    yield fork(getDemandConfig);
  }
}

export function* watchGetRcConfig() {
  while (true) {
    yield take(operationActions.GET_RC_CONFIG[REQUEST]);
    yield fork(getRcConfig);
  }
}

export function* watchGetConsignmentsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_CONSIGNMENTS[REQUEST]);
    yield fork(getConsignments, params);
  }
}

export function* watchGetViaPointsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_VIA_POINTS[REQUEST]);
    yield fork(getViaPoints, params);
  }
}

export function* watchGetOperationSearchSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_OPERATION_SEARCH[REQUEST]);
    yield fork(getOperationSearch, params);
  }
}

export function* watchGetAddressDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_ADDRESS_DETAILS[REQUEST]);
    yield fork(getAddressDetails, params);
  }
}

export function* watchViewFilesDocketSaga() {
  while (true) {
    const { params } = yield take(operationActions.VIEW_FILES_DOCKET[REQUEST]);
    yield fork(viewFilesDocket, params);
  }
}

export function* watchViewInvoiceSaga() {
  while (true) {
    const { params } = yield take(operationActions.VIEW_INVOICE[REQUEST]);
    yield fork(viewInvoiceDoc, params);
  }
}

export function* watchViewInsuranceSaga() {
  while (true) {
    const { params } = yield take(operationActions.VIEW_INSURANCE[REQUEST]);
    yield fork(viewInsuranceDoc, params);
  }
}

export function* watchGetTripDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_TRIP_DETAILS[REQUEST]);
    yield fork(getTripDetails, params);
  }
}

export function* watchGetCurrentDocketSaga() {
  while (true) {
    const { docketId } = yield take(operationActions.GET_CURRENT_DOCKET[REQUEST]);
    yield fork(getCurrentDocket, docketId);
  }
}

export function* watchGetBankDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_BANK_DETAILS[REQUEST]);
    yield fork(getBankDetails, params);
  }
}

export function* watchGetDocketsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_DOCKETS[REQUEST]);
    yield fork(getDockets, params);
  }
}

export function* watchGetInvoicesSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_INVOICES[REQUEST]);
    yield fork(getInvoices, params);
  }
}

export function* watchGetInsuranceSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_INSURANCE[REQUEST]);
    yield fork(getInsurance, params);
  }
}

export function* watchUpdateBasicDetailSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_BASIC_DETAIL[REQUEST]);
    yield fork(updateBasicDetail, payload);
  }
}

export function* watchUpdateVehicleStateSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_VEHICLE_STATE[REQUEST]);
    yield fork(updateVehicleState, payload);
  }
}

export function* watchUpdateTimeSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_TIME[REQUEST]);
    yield fork(updateTime, payload);
  }
}

export function* watchUpdateLocationSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_LOCATION[REQUEST]);
    yield fork(updateLocation, payload);
  }
}

export function* watchUpdateStoppageReason() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_STOPPAGE_REASON[REQUEST]);
    yield fork(updateStoppageReason, payload);
  }
}

export function* watchCreateViaPointSaga() {
  while (true) {
    const { payload } = yield take(operationActions.CREATE_VIA_POINT[REQUEST]);
    yield fork(createViaPoint, payload);
  }
}

export function* watchEditViaPointSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_VIA_POINT[REQUEST]);
    yield fork(editViaPoint, payload);
  }
}

export function* watchGetConsignerCodesSaga() {
  while (true) {
    const { payload } = yield take(operationActions.GET_CONSIGNER_CODES[REQUEST]);
    yield fork(getConsignerCodes, payload);
  }
}

export function* watchSaveRcDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_RC_DETAILS[REQUEST]);
    yield fork(saveRcDetails, payload);
  }
}

export function* watchSaveInvoiceSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_INVOICE_DETAILS[REQUEST]);
    yield fork(submitInvoice, payload);
  }
}

export function* watchSavePodStatus() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_POD_STATUS[REQUEST]);
    yield fork(submitPodStatus, payload);
  }
}

export function* watchSaveInsuranceSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_INSURANCE_DETAILS[REQUEST]);
    yield fork(submitInsurance, payload);
  }
}

export function* watchCreateDocketSaga() {
  while (true) {
    const { payload } = yield take(operationActions.CREATE_DOCKET[REQUEST]);
    yield fork(createDocket, payload);
  }
}

export function* watchsharePaymentLink() {
  while (true) {
    const { payload } = yield take(operationActions.SHARE_PAYMENT_LINK[REQUEST]);
    yield fork(sharePaymentLink, payload);
  }
}

export function* watchTriggerConsignerForBilti() {
  while (true) {
    const { params } = yield take(operationActions.TRIGGER_CONSIGNER_FOR_BILTI[REQUEST]);
    yield fork(triggerConsignerForBilti, params);
  }
}

export function* watchEditStartPointSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_START_POINT[REQUEST]);
    yield fork(editStartPoint, payload);
  }
}

export function* watchEditEndPointSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_END_POINT[REQUEST]);
    yield fork(editEndPoint, payload);
  }
}

export function* watchCreateInvoiceSaga() {
  while (true) {
    const { payload } = yield take(operationActions.CREATE_INVOICE[REQUEST]);
    yield fork(createInvoice, payload);
  }
}

export function* watchEditInvoiceSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_INVOICE[REQUEST]);
    yield fork(editInvoice, payload);
  }
}

// export function* watchEditInsuranceSaga() {
//   while (true) {
//     const { payload } = yield take(operationActions.EDIT_INSURANCE[REQUEST]);
//     yield fork(editInsurance, payload);
//   }
// }

export function* watchEditDocketSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_DOCKET[REQUEST]);
    yield fork(editDocket, payload);
  }
}

export function* watchSaveRcUrlSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_RC_URL[REQUEST]);
    yield fork(saveRcUrl, payload);
  }
}

export function* watchAddExpenseSaga() {
  while (true) {
    const { payload } = yield take(operationActions.ADD_EXPENSE[REQUEST]);
    yield fork(addExpense, payload);
  }
}

export function* watchEditExpenseSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_EXPENSE[REQUEST]);
    yield fork(editExpense, payload);
  }
}

export function* watchSettleOperatorSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SETTLE_OPERATOR[REQUEST]);
    yield fork(settleOperator, payload);
  }
}

export function* watchSaveBasicDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_BASIC_DETAILS[REQUEST]);
    yield fork(saveBasicDetails, payload);
  }
}

export function* watchSettleShipperSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SETTLE_SHIPPER[REQUEST]);
    yield fork(settleShipper, payload);
  }
}

export function* watchUpdateDemandDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_DEMAND_DETAILS[REQUEST]);
    yield fork(updateDemandDetails, payload);
  }
}

export function* watchUpdateFreightDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_FREIGHT_DETAILS[REQUEST]);
    yield fork(updateFreightDetails, payload);
  }
}

export function* watchUpdateOperatorFreightDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPDATE_OPERATOR_FREIGHT_DETAILS[REQUEST]);
    yield fork(updateOperatorFreightDetails, payload);
  }
}

export function* watchCreateTransactionSaga() {
  while (true) {
    const { payload } = yield take(operationActions.CREATE_TRANSACTION[REQUEST]);
    yield fork(createTransaction, payload);
  }
}

export function* watchEditTransactionSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_TRANSACTION[REQUEST]);
    yield fork(editTransaction, payload);
  }
}

export function* watchGetRcUrlSaga() {
  while (true) {
    const { payload } = yield take(operationActions.GET_RC_URL[REQUEST]);
    yield fork(getRcUrl, payload);
  }
}

export function* watchGetRelationDocUrlSaga() {
  while (true) {
    const { payload } = yield take(operationActions.GET_RELATION_DOC_URL[REQUEST]);
    yield fork(getRelationDocUrl, payload);
  }
}

export function* watchGetInvoiceDocUrlSaga() {
  while (true) {
    const { payload } = yield take(operationActions.GET_INVOICE_DOC_URL[REQUEST]);
    yield fork(getInvoiceDocUrl, payload);
  }
}

export function* watchGetInsuranceDocUrlSaga() {
  while (true) {
    const { payload } = yield take(operationActions.GET_INSURANCE_DOC_URL[REQUEST]);
    yield fork(getInsuranceDocUrl, payload);
  }
}

export function* watchEditDriverDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_DRIVER_DETAILS[REQUEST]);
    yield fork(editDriverDetails, payload);
  }
}

export function* watchEditInvoiceDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_INVOICE_DETAILS[REQUEST]);
    yield fork(editInvoiceDetails, payload);
  }
}

export function* watchDeleteDocketSaga() {
  while (true) {
    const { payload } = yield take(operationActions.DELETE_DOCKET[REQUEST]);
    yield fork(deleteDocket, payload);
  }
}

export function* watchDeleteInvoiceSaga() {
  while (true) {
    const { payload } = yield take(operationActions.DELETE_INVOICE[REQUEST]);
    yield fork(deleteInvoice, payload);
  }
}

export function* watchUploadFilesDocketSaga() {
  while (true) {
    const { payload } = yield take(operationActions.GET_DOCKET_FILE_UPLOAD[REQUEST]);

    yield fork(getDocketFileUpload, payload);
  }
}

export function* watchUploadFreightSaga() {
  while (true) {
    const { params } = yield take(operationActions.UPLOAD_FREIGHT[REQUEST]);
    yield fork(uploadFreight, params);
  }
}

export function* watchEditVehicleDetailsSaga() {
  while (true) {
    const { payload } = yield take(operationActions.EDIT_VEHICLE_DETAILS[REQUEST]);
    yield fork(editVehicleDetails, payload);
  }
}

export function* watchGetSupplyDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_SUPPLY_DETAILS[REQUEST]);
    yield fork(getSupplyDetails, params);
  }
}

export function* watchGetBasicDetailsSaga() {
  while (true) {
    const { consignmentId } = yield take(operationActions.GET_BASIC_DETAILS[REQUEST]);
    yield fork(getBasicDetails, consignmentId);
  }
}

export function* watchGetDemandDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_DEMAND_DETAILS[REQUEST]);
    yield fork(getDemandDetails, params);
  }
}

export function* watchgetPaymentBillingDataSaga() {
  while (true) {
    const { demandId } = yield take(operationActions.GET_PAYMENT_BILLING_DATA[REQUEST]);
    yield fork(getPaymentBillingData, demandId);
  }
}

export function* watchSubmitPaymentBillingSaga() {
  while (true) {
    const { payload, id } = yield take(operationActions.SUBMIT_PAYMENT_BILLING[REQUEST]);
    yield fork(submitBillingData, payload, id);
  }
}
export function* watchGetOperatorByPhoneSaga() {
  while (true) {
    const { phone } = yield take(operationActions.GET_OPERATOR_BY_PHONE[REQUEST]);
    yield fork(getOperatorByPhone, phone);
  }
}

export function* watchGetThirdPartyDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_THIRD_PARTY_DETAILS[REQUEST]);
    yield fork(getThirdPartyDetails, params);
  }
}

export function* watchGetActivityDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_ACTIVITY_DETAILS[REQUEST]);
    yield fork(getActivityDetails, params);
  }
}

export function* watchGetCommentCategoriesSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_COMMENT_CATEGORIES[REQUEST]);
    yield fork(getCommentCategories, params);
  }
}

export function* watchPostCommentSaga() {
  while (true) {
    const { payload } = yield take(operationActions.POST_COMMENT[REQUEST]);
    yield fork(postComment, payload);
  }
}

export function* watchDeleteExpenseSaga() {
  while (true) {
    const { payload } = yield take(operationActions.DELETE_EXPENSE[REQUEST]);
    yield fork(deleteExpense, payload);
  }
}

export function* watchViewRcValidationSaga() {
  while (true) {
    const { params } = yield take(operationActions.VIEW_RC_RELATION_DOC_URL[REQUEST]);
    yield fork(viewRcRelationDoc, params);
  }
}
export function* watchGetPodDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_POD_DETAILS[REQUEST]);
    yield fork(getPodDetails, params);
  }
}

export function* watchGetPodHistorySaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_POD_HISTORY[REQUEST]);
    yield fork(getPodHistory, params);
  }
}

export function* watchSubmitPodDetails() {
  while (true) {
    const { payload } = yield take(operationActions.SUBMIT_POD_DETAILS[REQUEST]);
    yield fork(submitPodDetails, payload);
  }
}

export function* watchUploadPodDocumentSaga() {
  while (true) {
    const { payload } = yield take(operationActions.UPLOAD_POD_DOCUMENTS[REQUEST]);

    yield fork(uploadPodDocument, payload);
  }
}

// export function* watchSubmitPodFileDetails() {
//   while (true) {
//     const { payload } = yield take(operationActions.SUBMIT_POD_FILE_DETAILS[REQUEST]);

//     yield fork(submitPodFileDetails, payload);
//   }
// }

export function* watchViewPodDocumentSaga() {
  while (true) {
    const { params } = yield take(operationActions.VIEW_POD_DOCUMENT[REQUEST]);

    yield fork(viewPodDocument, params);
  }
}

export function* watchGetPodValidityRemarkSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_POD_VALIDITY_REMARK[REQUEST]);
    yield fork(getPodValidityRemark, params);
  }
}
export function* watchAddressDetailsOperationSagaV4() {
  while (true) {
    const { params } = yield take(operationActions.GET_ADDRESS_DETAILS_OPERATIONV4[REQUEST]);
    yield fork(getAddressDetailsOperationV4, params);
  }
}
// export function* getEmailListAction(actions) {
//   console.log('actions',actions)
//     const request = api.getEmailsListRequestOperations(actions.params);
//     yield fetchEntitySpawn(request, operationActions.getEmailsList, actions.params);
//   }

// function* operationsSaga (){
//   yield takeLatest(operationActions.GET_EMAILS_LIST[REQUEST], getEmailListAction );

// }
export function* watchGetStatesDocketSaga() {
  while (true) {
    const { params } = yield take(operationActions.FETCH_STATES_FOR_DOCKET[REQUEST]);
    yield fork(getStatesDocket, params);
  }
}

export function* watchGetTripMapDetailsSaga() {
  while (true) {
    const { params } = yield take(operationActions.FETCH_TRIP_MAP_DETAILS[REQUEST]);
    yield fork(getTripMapDetails, params);
  }
}

// export default operationsSaga;

export function* watchGetTripItinerarySaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_TRIP_ITINERARY[REQUEST]);
    yield fork(getTripItinerary, params);
  }
}

export function* watchGetDelayReasonsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_DELAY_REASONS[REQUEST]);
    console.log(params, 'params----');
    yield fork(getDelayReasons, params);
  }
}

export function* watchGetCancelReasonsSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_CANCEL_REASONS[REQUEST]);
    yield fork(getCancelReasons, params);
  }
}

export function* watchSubmitDelayReasonSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_DELAY_REASON[REQUEST]);
    yield fork(submitDelayReason, payload);
  }
}

export function* watchSubmitCancelReasonSaga() {
  while (true) {
    const { payload } = yield take(operationActions.SAVE_CANCEL_REASON[REQUEST]);
    yield fork(submitCancelReason, payload);
  }
}

export function* watchExtraExpensePolicySaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_EXTRA_EXPENSE_POLICY[REQUEST]);
    yield fork(getExtraExpensePolicyData, params);
  }
}

export function* watchGetImageUrlSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_IMAGE_URL[REQUEST]);
    yield fork(viewUploadedDocument, params);
  }
}

export function* watchUpdateReferenceIdSaga() {
  while (true) {
    const { params } = yield take(operationActions.UPDATE_REFERENCE_ID[REQUEST]);
    yield fork(updateReferenceId, params);
  }
}

export function* getPhoneNo(params) {
  const request = api.phoneNoRequest.bind(null, params);
  yield fetchEntity(request, operationActions.getPhoneNo, null);
}

export function* watchGetPhoneNoSaga() {
  while (true) {
    const { params } = yield take(operationActions.GET_PHONE_NO[REQUEST]);
    yield fork(getPhoneNo, params);
  }
}

export function* watchSubmitDocketImages() {
  while (true) {
    const { params } = yield take(operationActions.SUBMIT_DOCKET_IMAGES[REQUEST]);
    yield fork(submitDocketImages, params);
  }
}

export function* watchGetImageProofDocketDetails() {
  while (true) {
    const { params } = yield take(operationActions.GET_IMAGE_PROOF_DOCKET_DETAILS[REQUEST]);
    console.log(params, 'params');
    yield fork(getImageProofDocketDetails, params);
  }
}

export function* watchSubmitDelayModal() {
  while (true) {
    const { params } = yield take(operationActions.SUBMIT_DELAY_MODAL[REQUEST]);
    yield fork(submitDelayReasonModal, params);
  }
}

export function* watchGetDelayModalData() {
  while (true) {
    const { params } = yield take(operationActions.GET_DELAY_MODAL_DATA[REQUEST]);
    yield fork(getDelayModalData, params);
  }
}

export function* watchGenerateEwayBillNumber() {
  while (true) {
    const { params } = yield take(operationActions.GENERATE_EWAY_BILL_NUMBER[REQUEST]);
    yield fork(generateEwayBillNumber, params);
  }
}
